<template>
  <div>
    <Modal v-model="modal1" width="760">
      <div slot="header">
        <span>票据类型</span>
        <Radio style="margin-left: 20px" size="small" v-model="single"
          >企业</Radio
        >
      </div>
      <div style="margin-top: 20px">
        <vxe-table
          border
          ref="xTable1"
          height="300"
           row-id="isDefault"
          :data="tableDatas"
          :radio-config="{ highlight: true, checkRowKey: defaultSelecteRow }"
          @radio-change="radioChangeEvent"
        >
          <vxe-column type="radio" width="60" title="选择">
          </vxe-column>
          <vxe-column field="invoiceName" title="开票名称"></vxe-column>
          <vxe-column field="invoiceTaxId" title="税号"></vxe-column>
        </vxe-table>
      </div>
      <div slot="footer" style="text-align: center;">
        <Button type="primary" @click="confirmFuzhu" class="mr10">保存</Button>
        <Button type="default" @click="modal1 = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      str:'',
      single: true,
      // shopId :'',
      tableDatas: [],
      ids:'',
      row:{},
      shopID:'',
      defaultSelecteRow: 1 // 默认选中
    }
  },
  methods: {
    // 单击
    radioChangeEvent({row}) {
      this.row = row
      console.log(row);
    },
    // 保存
    confirmFuzhu() {
    //  if(this.tableDatas.length>0){

    //  }
    console.log(this.row);
     if(this.row != []){
      this.$emit('hehehe',this.row,this.shopID)
     this.modal1 = false
     }else{
       this.$Message.error('请选择一条数据')
     }
    },
    // 筛选默认发票
    isVolice(){
      console.log('1111');
      let val = this.tableDatas.filter((item)=>{
        return item.isDefault == 1
      })
      console.log(val);
      this.row = val[0]
    }
 
  },

}
</script>

<style lang="less" scoped>

</style>
